var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.currentCoordinatesFormatted)?[_vm._v(" "+_vm._s(_vm.currentCoordinatesFormatted.lat)+", "+_vm._s(_vm.currentCoordinatesFormatted.lng)+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }